import { Component, OnInit, Input, OnChanges, SimpleChange, ElementRef, Output, EventEmitter } from '@angular/core';
import {Warehouse, Warehouse5} from '../../project/warehouse';
import {Frame5Component} from '../frames/frame5.component';
import * as d3 from 'd3';


@Component({
  selector: 'app-wind-column5',
  templateUrl: './wind-columns.component.html'
})
export class WindColumn5Component extends Frame5Component implements OnInit,  OnChanges {

  @Input() b: boolean;
  @Input() max_sep: number;

  constructor(el: ElementRef) {
    super(el);
    this.div = "#wind-column";
  }

  ngOnInit(){
    this.width = 400 - this.margin.left - this.margin.right;
    this.height = 400 - this.margin.top - this.margin.bottom;
    this.initFrame();
    this.isInit = true;

  }

  ngOnChanges(){
      if(this.isInit) {
        this.svg.selectAll(".wind-column").remove();
        if(this.max_sep > 0) {
            this.createWindColumns();
        }
      }
  }

  initFrame(){
    this.prepareData();
    this.createFrame();
    this.drawB();
    if(this.data.has_door) {
        this.addDoor();
    }
    if(this.max_sep > 0) {
        this.createWindColumns();
    }
  }
    
  createWindColumns() {
      // left side of warehouse
      if (!this.data.has_door) {
          let init = this.origin[0];
          let length = this.data.column_distance;
          let left_height = this.data.height_l
          this.drawColumns(init, length, left_height, this.data.slope_l);
      } else {
          // the wind columns on the door will be drawed on the end of addDoor()
          // left side of door
          let init = this.origin[0];
          let length = (this.data.column_distance - this.data.opening_width) / 2;
          let left_height = this.data.height_l
          this.drawColumns(init, length, left_height, this.data.slope_l);
          // right side of door
          init = this.origin[0] + (this.data.column_distance + this.data.opening_width) / 2;
          length = this.data.column_distance -  (this.data.column_distance + this.data.opening_width) / 2;
          left_height = this.data.height_l - ((this.data.column_distance + this.data.opening_width) / 2) * this.data.slope_l;
          this.drawColumns(init, length, left_height, this.data.slope_l);   
      }
      // right side of warehouse
      let init = this.origin[0] + this.data.column_distance;
      let length = this.data.width_l - this.data.column_distance;
      let left_height = this.data.height_l - this.data.column_distance * this.data.slope_l;
      this.drawColumns(init, length, left_height, this.data.slope_l);
      
  }
    
  drawColumns(init, length, left_height, slope){
      let max_sep = this.max_sep * this.factor
      let size = Math.ceil( length / max_sep );
      let separation = (length / size)
      let height : number;
      size--;
      for(let i = 0; i < size; i++) {
          let distance = separation * (i+1);
          height = left_height - distance * slope;
          let d = this.svg.append("line")
                  .style("stroke", "#68a2ff")
                  .style("stroke-width", 5)
                  .attr("class", "wind-column")
                  .attr("x1", init + distance)
                  .attr("y1", this.origin[1])
                  .attr("x2", init + distance)
                  .attr("y2", this.origin[1] - height);
      }
  }

  drawB(){
    let bl = this.data.width_l*this.data.slope_l + this.data.hb_additional_height;
    let br = this.data.width_l*this.data.slope_l + this.data.hb_additional_height;
    if(this.b){
      let b = this.svg.append("line")
        .style("stroke", "#68a2ff")
        .style("stroke-width", 3)
        .attr("class", "b")
        .attr("x1", this.origin[0])
        .attr("y1", this.origin[1]-this.data.height_r-this.radio)
        .attr("x2", this.origin[0])
        .attr("y2", this.origin[1]-this.data.height_r-bl);
      b = this.svg.append("line")
        .style("stroke", "#68a2ff")
        .style("stroke-width", 3)
        .attr("class", "b")
        .attr("x1", this.origin[0]+this.data.width_l)
        .attr("y1", this.origin[1]-this.data.height_r-this.radio)
        .attr("x2", this.origin[0]+this.data.width_l)
        .attr("y2", this.origin[1]-this.data.height_r-br);
    
    } else {
      this.svg.selectAll(".b").remove();
    }
  }
    
  addDoor(){
    let width = this.data.opening_width;
    let height = this.data.opening_height;
    let padding = (this.data.column_distance - width)/2;
    let d1 = this.svg.append("line")
      .style("stroke", "#68a2ff")
      .style("stroke-width", 5)
      .attr("class", "d1")
      .attr("x1", this.origin[0] + padding)
      .attr("y1", this.origin[1])
      .attr("x2", this.origin[0] + padding)
      .attr("y2", this.origin[1] - height);
    let d2 = this.svg.append("line")
      .style("stroke", "#68a2ff")
      .style("stroke-width", 5)
      .attr("class", "d2")
      .attr("x1", this.origin[0] + padding)
      .attr("y1", this.origin[1] - height)
      .attr("x2", this.origin[0] + padding + width)
      .attr("y2", this.origin[1] - height);
    let d3 = this.svg.append("line")
      .style("stroke", "#68a2ff")
      .style("stroke-width", 5)
      .attr("class", "d3")
      .attr("x1", this.origin[0] + padding + width)
      .attr("y1", this.origin[1] - height)
      .attr("x2", this.origin[0] + padding + width)
      .attr("y2", this.origin[1]);
    let circle1 = this.svg.append("circle")
      .style("fill", "#77768d")
      .attr("cx", this.origin[0] + padding)
      .attr("cy", this.origin[1])
      .attr("r", this.radio);
    let circle2 = this.svg.append("circle")
    .style("fill", "#77768d")
      .attr("cx", this.origin[0] + padding)
      .attr("cy", this.origin[1] - height)
      .attr("r", this.radio);
    let circle3 = this.svg.append("circle")
      .style("fill", "#77768d")
      .attr("cx", this.origin[0] + padding + width)
      .attr("cy", (this.origin[1] - height))
      .attr("r", this.radio);
    let circle4 = this.svg.append("circle")
      .style("fill", "#77768d")
      .attr("cx", this.origin[0] + padding + width)
      .attr("cy", this.origin[1])
      .attr("r", this.radio);
      
    // draw wind columns on the door
    let wc1 = this.svg.append("line")
                  .style("stroke", "#68a2ff")
                  .style("stroke-width", 5)
                  .attr("class", "wind-column-door")
                  .attr("x1", this.origin[0] + padding)
                  .attr("y1", this.origin[1])
                  .attr("x2", this.origin[0] + padding)
                  .attr("y2", this.origin[1] - (this.data.height_l - padding * this.data.slope_l)); // always on the left side of warehouse
     let wc2 = this.svg.append("line")
                  .style("stroke", "#68a2ff")
                  .style("stroke-width", 5)
                  .attr("class", "wind-column-door")
                  .attr("x1", this.origin[0] + padding + width)
                  .attr("y1", this.origin[1])
                  .attr("x2", this.origin[0] + padding + width)
                  .attr("y2", this.origin[1] - (this.data.height_l - (padding + width) * this.data.slope_l)); // always on the right side of warehouse
      
  }

  
}


// WEBPACK FOOTER //
// ./src/app/sketch/wind-columns/wind-column5.component.ts